import React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgPlusClockOffsetIcon = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Clock with a plus in the corner",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="20"
    height="22"
    viewBox="0 0 20 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <g clipPath="url(#clip0_25158_5024)">
      <path
        d="M13.1992 6.4375H17.9258"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5625 4.07422V8.80078"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <g clipPath="url(#clip1_25158_5024)">
      <path
        d="M17.5 12.125C17.182 15.975 13.932 19 10 19C8.01088 19 6.10322 18.2098 4.6967 16.8033C3.29018 15.3968 2.5 13.4891 2.5 11.5C2.5 7.56797 5.525 4.31797 9.375 4"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 7.125V11.5H14.375"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_25158_5024">
        <rect
          width="6.875"
          height="6.875"
          fill="white"
          transform="translate(12.125 3)"
        />
      </clipPath>
      <clipPath id="clip1_25158_5024">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 1.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const PlusClockOffsetIcon = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgPlusClockOffsetIcon />
  </BaseIcon>
);

export default PlusClockOffsetIcon;
